/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppStrategiesRouteImport } from './routes/_app/strategies'
import { Route as AppPoolsRouteImport } from './routes/_app/pools'
import { Route as AppInstrumentsRouteImport } from './routes/_app/instruments'
import { Route as AppAccountsRouteImport } from './routes/_app/accounts'
import { Route as AppRunsIndexRouteImport } from './routes/_app/runs.index'
import { Route as AppPresetsIndexRouteImport } from './routes/_app/presets.index'
import { Route as AppRunsIdRouteImport } from './routes/_app/runs.$id'
import { Route as AppPresetsNewRouteImport } from './routes/_app/presets.new'
import { Route as AppPresetsIdRouteImport } from './routes/_app/presets.$id'
import { Route as AppAccountsIdRouteImport } from './routes/_app/accounts_.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppStrategiesRoute = AppStrategiesRouteImport.update({
  id: '/strategies',
  path: '/strategies',
  getParentRoute: () => AppRoute,
} as any)
const AppPoolsRoute = AppPoolsRouteImport.update({
  id: '/pools',
  path: '/pools',
  getParentRoute: () => AppRoute,
} as any)
const AppInstrumentsRoute = AppInstrumentsRouteImport.update({
  id: '/instruments',
  path: '/instruments',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountsRoute = AppAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AppRoute,
} as any)
const AppRunsIndexRoute = AppRunsIndexRouteImport.update({
  id: '/runs/',
  path: '/runs/',
  getParentRoute: () => AppRoute,
} as any)
const AppPresetsIndexRoute = AppPresetsIndexRouteImport.update({
  id: '/presets/',
  path: '/presets/',
  getParentRoute: () => AppRoute,
} as any)
const AppRunsIdRoute = AppRunsIdRouteImport.update({
  id: '/runs/$id',
  path: '/runs/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppPresetsNewRoute = AppPresetsNewRouteImport.update({
  id: '/presets/new',
  path: '/presets/new',
  getParentRoute: () => AppRoute,
} as any)
const AppPresetsIdRoute = AppPresetsIdRouteImport.update({
  id: '/presets/$id',
  path: '/presets/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountsIdRoute = AppAccountsIdRouteImport.update({
  id: '/accounts_/$id',
  path: '/accounts/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/accounts': typeof AppAccountsRoute
  '/instruments': typeof AppInstrumentsRoute
  '/pools': typeof AppPoolsRoute
  '/strategies': typeof AppStrategiesRoute
  '/accounts/$id': typeof AppAccountsIdRoute
  '/presets/$id': typeof AppPresetsIdRoute
  '/presets/new': typeof AppPresetsNewRoute
  '/runs/$id': typeof AppRunsIdRoute
  '/presets/': typeof AppPresetsIndexRoute
  '/runs/': typeof AppRunsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/accounts': typeof AppAccountsRoute
  '/instruments': typeof AppInstrumentsRoute
  '/pools': typeof AppPoolsRoute
  '/strategies': typeof AppStrategiesRoute
  '/': typeof AppIndexRoute
  '/accounts/$id': typeof AppAccountsIdRoute
  '/presets/$id': typeof AppPresetsIdRoute
  '/presets/new': typeof AppPresetsNewRoute
  '/runs/$id': typeof AppRunsIdRoute
  '/presets': typeof AppPresetsIndexRoute
  '/runs': typeof AppRunsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/accounts': typeof AppAccountsRoute
  '/_app/instruments': typeof AppInstrumentsRoute
  '/_app/pools': typeof AppPoolsRoute
  '/_app/strategies': typeof AppStrategiesRoute
  '/_app/': typeof AppIndexRoute
  '/_app/accounts_/$id': typeof AppAccountsIdRoute
  '/_app/presets/$id': typeof AppPresetsIdRoute
  '/_app/presets/new': typeof AppPresetsNewRoute
  '/_app/runs/$id': typeof AppRunsIdRoute
  '/_app/presets/': typeof AppPresetsIndexRoute
  '/_app/runs/': typeof AppRunsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/accounts'
    | '/instruments'
    | '/pools'
    | '/strategies'
    | '/accounts/$id'
    | '/presets/$id'
    | '/presets/new'
    | '/runs/$id'
    | '/presets/'
    | '/runs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/accounts'
    | '/instruments'
    | '/pools'
    | '/strategies'
    | '/'
    | '/accounts/$id'
    | '/presets/$id'
    | '/presets/new'
    | '/runs/$id'
    | '/presets'
    | '/runs'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/accounts'
    | '/_app/instruments'
    | '/_app/pools'
    | '/_app/strategies'
    | '/_app/'
    | '/_app/accounts_/$id'
    | '/_app/presets/$id'
    | '/_app/presets/new'
    | '/_app/runs/$id'
    | '/_app/presets/'
    | '/_app/runs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/strategies': {
      id: '/_app/strategies'
      path: '/strategies'
      fullPath: '/strategies'
      preLoaderRoute: typeof AppStrategiesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pools': {
      id: '/_app/pools'
      path: '/pools'
      fullPath: '/pools'
      preLoaderRoute: typeof AppPoolsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/instruments': {
      id: '/_app/instruments'
      path: '/instruments'
      fullPath: '/instruments'
      preLoaderRoute: typeof AppInstrumentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounts': {
      id: '/_app/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AppAccountsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/runs/': {
      id: '/_app/runs/'
      path: '/runs'
      fullPath: '/runs/'
      preLoaderRoute: typeof AppRunsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/presets/': {
      id: '/_app/presets/'
      path: '/presets'
      fullPath: '/presets/'
      preLoaderRoute: typeof AppPresetsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/runs/$id': {
      id: '/_app/runs/$id'
      path: '/runs/$id'
      fullPath: '/runs/$id'
      preLoaderRoute: typeof AppRunsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/presets/new': {
      id: '/_app/presets/new'
      path: '/presets/new'
      fullPath: '/presets/new'
      preLoaderRoute: typeof AppPresetsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/presets/$id': {
      id: '/_app/presets/$id'
      path: '/presets/$id'
      fullPath: '/presets/$id'
      preLoaderRoute: typeof AppPresetsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounts_/$id': {
      id: '/_app/accounts_/$id'
      path: '/accounts/$id'
      fullPath: '/accounts/$id'
      preLoaderRoute: typeof AppAccountsIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAccountsRoute: typeof AppAccountsRoute
  AppInstrumentsRoute: typeof AppInstrumentsRoute
  AppPoolsRoute: typeof AppPoolsRoute
  AppStrategiesRoute: typeof AppStrategiesRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAccountsIdRoute: typeof AppAccountsIdRoute
  AppPresetsIdRoute: typeof AppPresetsIdRoute
  AppPresetsNewRoute: typeof AppPresetsNewRoute
  AppRunsIdRoute: typeof AppRunsIdRoute
  AppPresetsIndexRoute: typeof AppPresetsIndexRoute
  AppRunsIndexRoute: typeof AppRunsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountsRoute: AppAccountsRoute,
  AppInstrumentsRoute: AppInstrumentsRoute,
  AppPoolsRoute: AppPoolsRoute,
  AppStrategiesRoute: AppStrategiesRoute,
  AppIndexRoute: AppIndexRoute,
  AppAccountsIdRoute: AppAccountsIdRoute,
  AppPresetsIdRoute: AppPresetsIdRoute,
  AppPresetsNewRoute: AppPresetsNewRoute,
  AppRunsIdRoute: AppRunsIdRoute,
  AppPresetsIndexRoute: AppPresetsIndexRoute,
  AppRunsIndexRoute: AppRunsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
